// Shared enums and base types
export enum UserRole {
  DOCTOR = 'DOCTOR',
  PATIENT = 'PATIENT',
  ADMIN = 'ADMIN',
}

export enum AppointmentStatus {
  // Online-payment hold: the slot is reserved while the patient pays. Released
  // (-> EXPIRED) by the backend sweeper if payment doesn't arrive within the TTL.
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  CONFIRMED = 'CONFIRMED',
  RESCHEDULED = 'RESCHEDULED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  ABSENT = 'ABSENT',
  // Online-payment hold lapsed without payment; slot was released.
  EXPIRED = 'EXPIRED'
}

export enum ServiceType {
  CLINIC_VISIT = 'CLINIC_VISIT',
  HOME_VISIT = 'HOME_VISIT',
  VIDEO_CONSULT = 'VIDEO_CONSULT',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

export interface BaseEntity {
  id: string;
  createdAt: Date;
  updatedAt: Date;
}